import { Injectable } from '@angular/core';
import { WidgetService } from '@core/widgets';

// provided in root because need this service to be a singleton to share properties between components
@Injectable({ providedIn: 'root' })
export class JtpSdkScriptService {
  public inProgress = false;
  public isLoaded = false;

  private _loading: Promise<boolean>;

  constructor(private widgetService: WidgetService) {}

  async loadScript() {
    if (this.isLoaded) {
      return true;
    }

    if (!this.inProgress) {
      this._loading = new Promise<boolean>((resolve, reject) => {
        this.inProgress = true;
        this.widgetService.appendJtpSdk(() => {
          this.inProgress = false;
          this.isLoaded = true;
          resolve(true);
        });
      });
    }

    if (this.inProgress) {
      return await this._loading;
    }
  }
}
